import {Button, Paper, Step, StepContent, StepLabel, Stepper} from '@material-ui/core';
import 'Core/components/TermsAndConditions/LegalAcceptance.sass';
import {acceptAgreements, getLegalAgreementsText} from 'Core/ducks/legalAcceptance';
import {isLoaded, toEither} from 'Core/models/Async';
import CoreRouteConstants from 'Core/CoreRouteConstants';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {useEffect, useState} from 'react';
import HtmlParser from 'react-html-parser';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router';
import {ReducerState} from 'rootReducer';
import Loading from 'Shared/components/Loading';
import {renderAsync} from 'Shared/components/RenderAsync';
import {logout} from 'Shared/utilities/Auth';
import {prop} from 'Shared/utilities/prop';

const LegalAcceptance = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {userClaims} = useSelector((state: ReducerState) => state.user.profile);
  const {legalAgreementTexts} = useSelector((state: ReducerState) => state.legalAcceptance);
  const [agreementStep, setAgreementStep] = useState(0);

  useEffect(() => {
    if (isLoaded(userClaims)) {
      dispatch(getLegalAgreementsText(userClaims.Data.unacceptedLegalDocuments.map(prop('id'))));
    }
  }, [dispatch, userClaims]);

  if (isLoaded(userClaims)) {
    const advanceAgreement = () => {
      if (agreementStep + 1 === userClaims.Data.unacceptedLegalDocuments.length) {
        dispatch(acceptAgreements(userClaims.Data.id, userClaims.Data.unacceptedLegalDocuments.map(prop('id'))));
      } else {
        setAgreementStep(agreementStep + 1);
      }
    };

    return pipe(
      legalAgreementTexts,
      toEither,
      E.fold(renderAsync, agreementsDictionary => (
        <Paper className="legal-acceptance">
          <p>Please accept the following agreements to continue:</p>
          <Stepper className="legal-acceptance__agreements" orientation="vertical" activeStep={agreementStep}>
            {userClaims.Data.unacceptedLegalDocuments.map(legalDocument => (
              <Step key={legalDocument.id}>
                <StepLabel>{legalDocument.legalDocumentType.name}</StepLabel>
                <StepContent>
                  <div className="legal-acceptance__agreement-text">
                    {HtmlParser(agreementsDictionary[legalDocument.id] || '')}
                  </div>
                  <div className="legal-acceptance__agreement-buttons">
                    <Button
                      className="legal-acceptance__agree-button"
                      variant="contained"
                      color="primary"
                      onClick={advanceAgreement}
                    >
                      I Accept
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => {
                        logout();
                        history.push(CoreRouteConstants.LOGIN);
                      }}
                    >
                      Decline
                    </Button>
                  </div>
                </StepContent>
              </Step>
            ))}
          </Stepper>
          <p className="legal-acceptance__description">
            By clicking "I Accept" above, I represent and warrant that I have read, understand and agree to abide by
            Allstate Benefits' Electronic Service Agreement and Producer HIPAA Business Associate Addendum. I understand
            that my access and any information viewed and used will be for purposes permitted under federal and state
            laws and regulations. I agree to only access and use the minimum necessary information required to complete
            the task for which I am accesssing the information.
          </p>
        </Paper>
      ))
    );
  } else {
    return <Loading />;
  }
};

export default LegalAcceptance;
